export default "__VITE_ASSET__Dop$Infw__"